import React from "react";
import { Box, Typography } from "@mui/material";
import { Colors } from "../../utils/Colors";

export default function PageShell({ title, subtitle, children }) {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        minHeight: "100%",
        backgroundColor: Colors.bg.app,
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: 22, md: 26 },
          fontWeight: 900,
          color: Colors.text.title,
          lineHeight: 1.2,
          mb: subtitle ? 0.5 : 2,
        }}
      >
        {title}
      </Typography>

      {subtitle ? (
        <Typography
          sx={{
            color: Colors.text.muted,
            mb: 2,
            fontSize: { xs: 14, md: 15 },
          }}
        >
          {subtitle}
        </Typography>
      ) : null}

      <Box
        sx={{
          backgroundColor: Colors.bg.paper,
          border: `1px solid ${Colors.border.light}`,
          borderRadius: 3,
          p: { xs: 2, md: 2.5 },
          boxShadow: Colors.shadow.brand,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}